








































































































































































































































































































































































// --- Components ---
import { Component, Prop, Vue } from 'vue-property-decorator';

// --- Models ---
import { Career, CareerSubject } from '@/models/Career.model';

// --- Services ---
import AppService from '@/services/app';
import CareerService from '@/services/career';
import DashboardService from '@/services/dashboard';

@Component
export default class JobLibrary extends Vue {
  // used by loaders
  isLoading: boolean = false;
    
  // used by data table that changes the footer
  mobileBreakpoint: number = 1263;
  descriptionMaxLength: number = 150;

  // used by Filter area
  selectedCareerCategory: string = '';
  selectedCareerSubCategoryId: string = '';
  selectedClassificationIdUno: string = '';
  selectedClassificationIdDos: string = '';
  keyword: string = '';
  criteriaUpdated: boolean = false;

  results: Career[] = [];

  // variables for career info dialog
  showInformationDialog: boolean = false;
  clickedCareer: Career = {
    id: 0,
    jobTitle: '',
    classification: '',
    description: '',
    disabled: false,
    hasRequiredSubjects: true,
  };
  qualifications: string[] = [];
  subjects: CareerSubject[] = [];

  async beforeMount() {
    await AppService.getCareerCategories(false);
    await AppService.getCareerSubCategories(false);
    await AppService.getClassifications(false);
  }

  get headers() {
    return [
      {
        text: 'Job Title',
        value: 'jobTitle',
      },
      {
        text: 'Description',
        value: 'jobDescription',
      },
      {
        sortable: false,
        text: '',
        value: 'action',
        align: 'end',
      },
    ];
  }

  trimDescription(description: string) {
    return (description.length > this.descriptionMaxLength) ? description.substring(0, this.descriptionMaxLength - 3) + '...' : description;
  }
  
  getItemsPerPage(items: Career[]) {
    let itemsPerPage: any[] = [];

    if (this.$vuetify.breakpoint.width > this.mobileBreakpoint) {
      // On larger viewport listing view
      if (items.length > 100) {
        itemsPerPage = [10, 25, 50, 100];          
      } else {
        itemsPerPage = [10, 25, 50, { text: 'All', value: -1}];
      }

    } else {
      // On the smaller viewport stacked view
      itemsPerPage = [5, 10, 25];

    }

    return { itemsPerPageOptions: itemsPerPage };
  }

  async doSearch() {
    try {
      // used for activate loading animation
      this.isLoading = true;

      const response = await CareerService.searchCareers({
        category: this.selectedCareerCategory,
        subCategoryId: this.selectedCareerSubCategoryId,
        classificationIdUno: this.selectedClassificationIdUno,
        classificationIdDos: this.selectedClassificationIdDos,
        keyword: this.keyword,
      });

      if (response && response.data) {
        if (response.data.result && response.data.result === 'false') {
          this.results = [];
        } else {
          this.results = response.data;
          this.criteriaUpdated = false;
        }
      } else {
        // response is undefined or has no data field - SHOULD NEVER HAPPEN!
        throw new Error('response: ' + JSON.stringify(response));
      }

    } catch (error) {
      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        AppService.errorHandler(
          this.$store.getters['app/messages'].couldNotConnect,
        );
      }
    } finally {
      this.isLoading = false;
    }
  }

  async addCareerToDashboard(careerId: number) {
    try {
      const response = await DashboardService.dashboardCareerCreate({ id: careerId });
      if (response && response.data) {
        if (response.data.result === 'false') {
          AppService.errorHandler(response.data.message);
        } else {
          AppService.successHandler(response.data.message);
        }
      } else {
        // response is undefined or has no data field - SHOULD NEVER HAPPEN!
        throw new Error('response: ' + JSON.stringify(response));
      }

    } catch (error) {
      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        AppService.errorHandler(
          this.$store.getters['app/messages'].couldNotConnect,
        );
      }
    } finally {
      this.isLoading = false;
    }
  }

  async showCareer(career: Career) {
    this.clickedCareer = career;

    if (this.clickedCareer.qualifications) {
      this.qualifications = this.clickedCareer.qualifications.split(',');
    }

    await this.getSubjectsByCareer();

    this.showInformationDialog = true;
  }

  async getSubjectsByCareer() {
    this.subjects = [];
    
    try {
      const response = await DashboardService.getSubjectsByCareer({ params: { careerId: this.clickedCareer.id }});

      if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            // do nothing, there are no subjects for this career            
          } else {
             this.subjects = response.data;
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }
    } catch (error) {
      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
      }
    }
  }

  goToQualification(qualification: string) {
    this.$router.push({ name: 'Search By Qualifications', query: {search: qualification.trim() } });
  }
}
